<template>
  <div>
    <van-skeleton
      avatar
      :row="3"
      :loading="loading"
    >
      <van-row gutter="8">
        <van-col span="2">
          <img :src="commentUserAvatar" style="width:100%;border-radius:50%" />
        </van-col>
        <van-col span="22">
          <van-row type="flex" justify="space-between" align="center">
            <van-col span="21">
              <div v-if="reply">
                <strong>{{commentUserName}}</strong>
                <span class="reply">回复</span>
                <strong>{{replyToUserName}}</strong>
              </div>
              <div v-else>
                <strong>{{commentUserName}}</strong>
              </div>
            </van-col>
            <van-col span="3" style="display:flex;justify-content:flex-end;">
              <LikeButton
                icon="good-job-o"
                round
                :count="comment.likes_count"
                applabel="social"
                classname="comment"
                :objectid="commentId"
                customStyle=""
              />
              <!-- <van-icon
                v-if="showMoreAction"
                name="ellipsis"
                color="#999"
                @click="moreAction"
              /> -->
            </van-col>
          </van-row>
          <div class="content-removed" v-if="comment.closed">
            评论已删除
          </div>
          <div class="content" v-else>
            {{comment.content}}
          </div>
          <van-row
            v-if="showActions"
            gutter="15"
            type="flex"
            align="center"
            class="meta">
            <van-col>
              {{datetime}}
            </van-col>
            <van-col v-if="showReply">
              <span class="button" @click="replyTo">
                <van-icon name="comment-o" />
              </span>
            </van-col>
            <van-col v-if="showDelete">
              <span class="button" @click="deleteComment">
                <van-icon name="delete" />
              </span>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </van-skeleton>
    <!-- <comment-thread
      :comment-id="commentId"
      :id="commentId"
      v-on:reply-to="replyTo"
      :ref="'commentThread' + commentId"
    /> -->
    <div v-if="comment.children.length > 0 && showThread">
      <van-row v-for="(commentId, index) in comment.children" :key="index" style="padding-top:5px;">
        <van-col span="22" offset="2">
          <comment-detail
            :comment-id="commentId"
            v-on:reply-to="replyTo"
            v-on:comment-closed="commentClosed"
            :ref="'commentThread' + commentId"
            :reply="true"
          />
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  // import CommentThread from './comment-thread.vue'
  import store from '../store/index';
  import LikeButton from './like-button.vue'
  import Vue from 'vue'
  import { Row, Col } from 'vant'
  import { Image } from 'vant'
  import { Icon } from 'vant'
  import { Skeleton } from 'vant'
  import {humanDateTime} from '../utils/time.js'
  import { Toast } from 'vant'
  import { Dialog } from 'vant'
  Vue.use(Row).use(Col)
  Vue.use(Image)
  Vue.use(Icon)
  Vue.use(Skeleton)
  Vue.use(Toast)

  export default {
    name: "comment-detail",
    components: {
      LikeButton
      // CommentThread
    },
    props: {
      commentId: Number,
      reply: Boolean, // 是否是回复
      showActions: { // 是否显示操作按钮（删除、回复）
        type: Boolean,
        default: true
      },
      // showMoreAction: { // 是否显示 moreAction 按钮
      //   type: Boolean,
      //   default: false
      // },
      showThread: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        loading: true,
        commentUserName: '',
        replyToUserName: '',
        commentUserAvatar: '',
        comment: {
          id: Number,
          user: Number,
          created: Number,
          likes_count: Number,
          content: String,
          replay_comment_id: Number,
          children: Array
        }
      }
    },
    computed: {
      datetime () {
        return humanDateTime(this.comment.created)
      },
      showReply () {
        if (this.comment.user == store.state.auth.uid || this.comment.closed) {
          return false
        } else {
          return true
        }
      },
      showDelete () {
        if (this.comment.user == store.state.auth.uid) {
          if (this.comment.closed == false) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      getComment() {
        let that = this
        that.$api.comment.detail(that.commentId).then(res => {
          that.comment = res.data
          that.$api.user.wechatProfile({user: res.data.user}).then(res => {
            window.console.log(res)
            let commentUser = res.data.results[0]
            that.commentUserName = commentUser.nickname
            that.commentUserAvatar = commentUser.headimgurl
            that.loading = false
          })
          if(this.reply) {
            that.$api.comment.detail(that.comment.object_id).then(res => {
              that.$api.user.wechatProfile({user: res.data.user}).then(res => {
                let replyToUser = res.data.results[0]
                that.replyToUserName = replyToUser.nickname
                // that.replyToUserAvatar = replyToUser.headimgurl
              })
            })
          }
        })
      },
      replyTo () {
        let parent
        if (this.comment.parent) {
          parent = this.comment.parent
        } else {
          parent = this.comment.id
        }
        this.$emit(
          'reply-to',
          this.commentUserName,
          parent, // parent
          'social', // applabel
          'comment', // classname
          this.commentId // objectid
        )
      },
      removeComment (commentId) {
        window.console.log("收到删除确认")
        let that = this
        that.$api.comment.close(commentId).then(res => {
          window.console.log("关闭comment成功")
          window.console.log(res)
          this.commentsCount -= 1
          Toast.success("评论已删除")
          that.commentClosed()
        })
      },
      commentClosed () {
        this.$emit("comment-closed")
      },
      deleteComment () {
        let that = this
        Dialog.confirm({
          title: '删除确认',
          message: '确定要删除本条评论吗？'
        }).then(() => {
          // on confirm
          // that.$emit('remove-comment', that.commentId)
          that.removeComment(that.commentId)
        }).catch(() => {
          window.console.log("取消")
        })
      }
    },
    watch: {
      commentId (value) {
        window.console.log("评论ID发生变化")
        window.console.log(value)
        this.getComment()
      }
    },
    mounted () {
      this.getComment()
    }
  }
</script>

<style lang="css" scoped>
  .content {
    font-size: 0.98em;
  }
  .content-removed {
    color: #999;
  }
  .meta {
    font-size: 0.9em;
    color: #999;
  }
  .button {
    /* margin-left: 15px; */
    padding: 0 5px;
  }
  .reply {
    margin: 0 8px;
    color: #999;
  }
</style>
